import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CustomerMetaFieldService = {
    getList: async () => {
        const response = await apiService.get("/customer-meta-fields",
            {
                headers: {
                    authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                },
            }
        );
        return response.data;
    },
    getDetail: async (id) => {
        const response = await apiService.get(`/customer-meta-fields/${id}`, {
            headers: {
                authorization: "Bearer " + _BaseAPIService.retrieveToken(),
            },
        });
        return response.data;
    },
    create: async (data) => {
        const response = await apiService.post("/customer-meta-fields", data, {
            headers: {
                authorization: "Bearer " + _BaseAPIService.retrieveToken(),
            },
        });
        return response.data;
    },
    update: async (updatedData) => {
        try {
            const response = await apiService.put(`/customer-meta-fields`, updatedData, {
                headers: {
                    authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error updating customer meta field:", error);
            throw error;
        }
    },
    delete: async (id) => {
        const response = await apiService.delete(`/customer-meta-fields/${id}`, {
            headers: {
                authorization: "Bearer " + _BaseAPIService.retrieveToken(),
            },
        });
        return response.data;
    },
    detailbycode: async (code) => {
        const response = await apiService.get(`/customer-meta-fields/by-code/${code}`, {
            headers: {
                authorization: "Bearer " + _BaseAPIService.retrieveToken(),
            },
        });
        return response.data;
    },
}

export default CustomerMetaFieldService;